import React from 'react';
import { Row, Col } from 'antd';
import { Rec, Ad, } from '../../component';
import wandu from '../../service/wandu';
import styles from './index.css';

export default class Home extends React.Component {

    state = {
        recommendNovels: [],
        hotNovels: [],
        latestNovels: [],
    }

    componentDidMount() {
        wandu.home().then(res => {
            const { recommend_novels, hot_novels, latest_novels } = res;
            let recommendNovels = [];
            let hotNovels = [];
            let latestNovels = [];
            if (recommend_novels && recommend_novels.length) {
                recommendNovels = recommend_novels.map(item => ({
                    novel_id: item.novel_id,
                    name: item.novel_name,
                    pic: item.pic,
                    author: item.author_name,
                    cata: item.tag_name,
                    brief: item.summary,
                }));
            }
            if (hot_novels && hot_novels.length) {
                hotNovels = hot_novels.map(item => ({
                    novel_id: item.novel_id,
                    name: item.novel_name,
                    pic: item.pic,
                    author: item.author_name,
                    cata: item.tag_name,
                    brief: item.summary,
                }));
            }
            if (latest_novels && latest_novels.length) {
                latestNovels = latest_novels.map(item => ({
                    novel_id: item.novel_id,
                    name: item.novel_name,
                    pic: item.pic,
                    author: item.author_name,
                    cata: item.tag_name,
                    brief: item.summary,
                    p_num: item.paragraph_num,
                    p_time: item.utime_paragraphs,
                }));
            }
            this.setState({ recommendNovels, hotNovels, latestNovels });
        }).catch(e => {
            console.log(e);
        });
    }

    render() {
        return (
            <div style={{ margin: '0px' }}>
                {(this.state.latestNovels && this.state.latestNovels.length) && <Rec.RecC data={this.state.latestNovels} />}
                {(this.state.recommendNovels && this.state.recommendNovels.length) && <Rec.RecA data={this.state.recommendNovels} />}
                {(this.state.hotNovels && this.state.hotNovels.length) && <Rec.RecB data={this.state.hotNovels} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/home/home.js